const fontFamilySKR = "'Noto Sans KR', Arial, sans-serif"
export const CHART = {
  BAR: {
    tooltip: {
      textStyle: {
        fontSize: 12,
        fontFamily: fontFamilySKR,
      },
      backgroundColor: '#1f2533',
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        interval: 0,
        color: '#8e9198',
        fontSize: 12,
        fontFamily: fontFamilySKR,
      },
      axisLine: {
        show: true,
        onZero: false,
        lineStyle: {
          color: '#787c84',
        },
      },
      splitLine: {
        lineStyle: {
          color: '#dddee0',
        },
      },
      splitNumber: 2,
      axisTick: { show: false },
    },
    xAxis: [
      {
        type: 'category',
        boundaryGap: true,
        silent: false,
        nameTextStyle: {
          color: '#8e9198',
          fontSize: 12,
          fontFamily: fontFamilySKR,
        },
        axisLabel: {
          interval: 0,
          color: '#8e9198',
          fontSize: 12,
          fontFamily: fontFamilySKR,
          formatter: function (value) {
            var res = value.split(' ');
            return res.join('\n');
          },
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: '#787c84',
          },
        },
        splitLine: { show: false },
        axisTick: { show: false },
      },
    ],
    series: {
      type: 'bar',
      barWidth: '40%',
    },
    legend: {
      textStyle: {
        color: '#8e9198',
        fontSize: 12,
        fontFamily: fontFamilySKR,
      },
      itemWidth: 10,
      itemHeight: 10,
    },
  },
  CHART_BAR: {
    title: {
      right: 20,
      top: 0,
    },
    tooltip: {
      textStyle: {
        fontSize: 12,
        fontFamily: fontFamilySKR,
      },
    },
    yAxis: {
      type: 'value',
      show: false,
    },
    xAxis: [
      {
        type: 'category',
        boundaryGap: true,
        silent: false,
        nameTextStyle: {
          color: '#959595',
          fontSize: 10,
          fontFamily: fontFamilySKR,
        },
        axisLabel: {
          interval: 0,
          color: '#959595',
          fontSize: 12,
          fontFamily: fontFamilySKR,
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: '#cccccc',
          },
        },
        splitLine: { show: false },
        axisTick: { show: false },
      },
    ],
    series: {
      type: 'bar',
      barWidth: '40%',
      label: {
        show: true,
        position: 'top',
        formatter: series => {
          return series.value.toLocaleString();
        },
      },
    },
  },
  CHART_LINE: {
    title: {
      right: 20,
      top: 0,
    },
    tooltip: {
      textStyle: {
        fontSize: 12,
        fontFamily: fontFamilySKR,
      },
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        show: false,
      },
      axisLine: {
        show: false,
      },
      splitLine: {
        lineStyle: {
          color: '#dddee0',
        },
      },
      splitNumber: 3,
      axisTick: { show: false },
    },
    xAxis: [
      {
        type: 'category',
        boundaryGap: true,
        silent: false,
        nameTextStyle: {
          color: '#959595',
          fontSize: 10,
          fontFamily: fontFamilySKR,
        },
        axisLabel: {
          color: '#959595',
          fontSize: 10,
          fontFamily: fontFamilySKR,
        },
        axisLine: {
          show: false,
        },
        splitLine: { show: false },
        axisTick: { show: false },
      },
    ],
    series: {
      symbolSize: 10,
      symbol: 'circle',
      type: 'line',
      lineStyle: {
        type: 'dotted',
      },
      label: {
        show: true,
        position: 'top',
        color: '#4b505b',
        fontSize: 10,
        fontFamily: fontFamilySKR,
        formatter: series => {
          return series.value.toLocaleString();
        },
      },
    },
  },
  CHART_GAUGE: {
    series: {
      type: 'gauge',
      startAngle: 180,
      endAngle: 0,
      min: 0,
      max: 100,
      splitNumber: 0,
      progress: {
        show: true,
        width: 30,
      },
      axisLine: {
        lineStyle: {
          width: 30,
        },
      },
      pointer: {
        show: false,
      },
      axisLabel: {
        show: false,
      },
      detail: {
        offsetCenter: [0, '-15%'],
        fontSize: 26,
        fontFamily: fontFamilySKR,
        fontWeight: 700,
        formatter: '{value}%',
      },
    },
  },
  CHART_PIE: {
    title: {
      left: 30,
      top: 15,
    },
    legend: {
      type: 'scroll',
      orient: 'vertical',
      right: 20,
      top: 'middle',
      itemGap: 8,
      textStyle: {
        color: '#8e9198',
        fontSize: 12,
        fontFamily: fontFamilySKR,
        rich: {
          title: {
            width: 110,
          },
          value: {
            align: 'right',
            width: 40,
          },
        },
      },
      itemWidth: 8,
      itemHeight: 8,
    },
    tooltip: {
      textStyle: {
        fontSize: 12,
        fontFamily: fontFamilySKR,
      },
    },
    series: {
      type: 'pie',
      radius: ['40%', '60%'],
      avoidLabelOverlap: false,
      right: 190,
      label: {
        show: false,
        position: 'center',
      },
      labelLine: {
        show: false,
      },
    },
  },
};
